import { ArrowRight } from "lucide-react";
function DashboardLandingStep({ form, labels, onRestart, planCatalog = [] }) {
  const selectedPlan = planCatalog.find((plan) => plan.plan_key === form.plan) || planCatalog[0] || { plan_key: form.plan, plan_name: form.plan, amount: 0, member_limit: 0 };

  const filledValue = (value, fallback = "Not provided") => {
    return value && String(value).trim() ? value : fallback;
  };

  const addDays = (date, days) => {
    const nextDate = new Date(date);
    nextDate.setDate(nextDate.getDate() + days);
    return nextDate;
  };

  const formatDate = (date) => {
    return new Intl.DateTimeFormat("en-IN", {
      day: "numeric",
      month: "short",
      year: "numeric",
    }).format(date);
  };

  const formatIndianMobile = (mobile) => {
    const digits = String(mobile || "").replace(/\D/g, "");
    if (digits.length !== 10) return filledValue(mobile);
    return `+91 ${digits.slice(0, 5)} ${digits.slice(5)}`;
  };

  const ownerFirstName = String(filledValue(form.ownerName, "Owner")).trim().split(/\s+/)[0];
  const companyName = filledValue(form.companyName, "Your company");
  const trialStarted = new Date();
  const trialEnds = addDays(trialStarted, 30);
  const teamLimit = `${Number(selectedPlan.member_limit || 0).toLocaleString("en-IN")} members`;
  const planName = selectedPlan.plan_name || selectedPlan.plan_key;
  const amountPaid = `₹${Number(selectedPlan.amount || 0).toFixed(2)} + GST`;

  const trialDetails = [
    { label: "Plan", value: planName, green: true },
    { label: "Trial started", value: formatDate(trialStarted) },
    { label: "Trial ends", value: formatDate(trialEnds) },
    { label: "Team size limit", value: teamLimit },
    { label: "Invoice sent to", value: filledValue(form.email) },
    { label: "Amount paid", value: amountPaid },
  ];



  return (
    <div className="step-content dashboard-landing kd-welcome-screen">
      <div className="kd-welcome-logo" aria-label="KaamDesk">
        <div className="kd-welcome-mark">क</div>
        <span><span>काम</span>Desk</span>
      </div>

      <div className="kd-trial-badge">
        <div className="kd-trial-icon">★</div>
        <div>
          <b>{planName} · Active</b>
          <span>All Growth features unlocked for {selectedPlan.plan_key === "Trial" ? "30 days" : "per month"}</span>
        </div>
      </div>

      <h2>Welcome {ownerFirstName}, Your company is live.</h2>
      <p className="kd-welcome-sub">
        <strong>{companyName}</strong> is now registered on KaamDesk. Your ₹{Number(selectedPlan.amount || 0).toFixed(2)} {selectedPlan.plan_name} plan gives you every Growth-tier feature for {selectedPlan.plan_key === "Trial" ? "30 days" : "per month"} — no restrictions, no hidden caps.
      </p>

      <section className="kd-trial-details" aria-label="Registration details">
        {trialDetails.map((row) => (
          <div className="kd-trial-row" key={row.label}>
            <span>{row.label}</span>
            <b className={row.green ? "green" : ""}>{row.value}</b>
          </div>
        ))}
      </section>

      {/* <div className="kd-welcome-checklist">
        {checklist.map((item, index) => (
          <div className="kd-welcome-check-item" key={item.title}>
            <div>{index + 1}</div>
            <span>
              <strong>{item.title}</strong>
              <small>{item.text}</small>
            </span>
          </div>
        ))}
      </div> */}

      <div className="kd-wa-confirm">
        <i>✓</i>
        <span>A WhatsApp confirmation with your invoice and trial details has been sent to {formatIndianMobile(form.mobile)}.</span>
      </div>

      <button className="primary-btn full kd-welcome-primary" onClick={onRestart}>
        {labels.goDashboard || "Go to Dashboard"}
        <ArrowRight size={20} />
      </button>
      <button className="kd-welcome-ghost" onClick={onRestart}>I'll explore on my own</button>
    </div>
  );
}

export default DashboardLandingStep;
